import { IField } from './Interfaces/IField';
import {
    SAVE_AUTHENTICATION,
    CHANGE_MODE,
    LOAD_USER_FIELDS,
    LOAD_USER_FIELDS_SUCCESS,
    LOAD_ALL_FIELDS,
    LOAD_ALL_FIELDS_LOADING,
    LOAD_ALL_FIELDS_SUCCESS,
    ADD_POLYGON,
    UPDATE_POLYGON,
    EDIT_POLYGON,
    REMOVE_POLYGON,
    CLEAR_POLYGONS,
    EDIT_FIELD_INFORMATION,
    EDIT_FIELD,
    SELECT_FIELD,
    TOGGLE_PROBLEMS,
    SHOW_SCOUTING_DATA,
    REFRESH_SCOUTING_DATA,
    SAVE_MAP_CENTER,
    SAVE_MAP_DATA,
    SAVE_MAP,
    LOAD_NDVI,
    LOAD_NDVI_SUCCESS,
    LOAD_NDVI_LIST,
    LOAD_NDVI_LIST_SUCCESS,
    LOAD_RECLAMATION,
    SAVE_RECLAMATION_DATA,
    LOAD_RECLAMATION_SUCCESS,
    LOAD_FERTILIZATION,
    LOAD_FERTILIZATION_SUCCESS,
    SAVE_NITROGEN_CONTENT,
    LOAD_ERROR,
    UPDATE_USER_FIELDS,
    SHOW_ALL_FIELDS,
    SHOW_SETTINGS,
    HIDE_INFO_PANEL,
    SHOW_SPRAYING,
    FIELD_FILTER,
    FIELD_ID_FILTER,
    RESET_FERTILIZATION,
    SELECT_FIELD_TO_MERGE,
    LOAD_CROPS,
    LOAD_CROPS_SUCCESS,
    UPDATE_FIELD_GROUPS,
    TOGGLE_SIMPLE_ACTION_MODAL,
    USER_LOGOUT,
    TOGGLE_NOTIFICATION_MODAL,
    SET_FERTILIZATION_PARAMS,
    SET_HEADER_SELECTOR_DISABILITY,
    TOGGLE_SHOW_MOBILE_MAP,
    TOGGLE_SHOW_FIELD_LIST,
    TOGGLE_MOBILE_MODAL_SELECT,
    SET_DISABLE_COMPANY_SELECT,
    FIELDS_LOADING,
    SAVE_MAP_ANALYSIS,
    CLEAR_MAP_ANALYSIS,
    LOAD_SCOUTING_LIST,
    LOAD_NDVI_DETAILS_SUCCESS,
    LOAD_NDVI_EXPENSES_SUCCESS,
    SET_NDVI_BOUNDS,
    SET_GROUP_STATE,
    SET_GROUP_SELECTED_FIELDS,
    SET_SOIL_ANALYSIS,
    SET_SCOUTING_LAT_LNG,
    SET_INFOPANEL_ISOPEN,
    SET_TASK_DATA,
    SET_EDITING_CLOSE_POPUP,
    SET_CLOSE_POPUP_MODAL_OPEN,
    SET_SPLITTING_FIELD,
    SET_FIELDS_FILTER_OPENED,
    LOAD_FIELD_DETAILS,
    SET_VISIBLE_FIELDS,
    SET_SHOW_POLYGON_LABEL,
    SET_POLYGON_LABEL_KEY,
    ADD_POLYGONS,
    SET_VRA_NDVI_OVERLAYS,
    SET_VRA_NDVI_LOADING,
    SET_VRA_MAP_LAYERS,
    SET_VRA_ANALYSIS_OVERLAYS,
    SET_LAYER_OPACITY,
} from './constants';

export const setShowPolygonLabel = (data) => ({
    type: SET_SHOW_POLYGON_LABEL,
    data,
});
export const setPolygonLabelKey = (data) => ({
    type: SET_POLYGON_LABEL_KEY,
    data,
});
/**
 * Load user fields
 *
 * @return {object} An action object with a type of LOAD_USER_FIELDS
 */
export function loadUserFields() {
    return {
        type: LOAD_USER_FIELDS,
    };
}

/**
 * User logout
 *
 * @return {object} An action object with a type of LOAD_USER_FIELDS
 */
export function userLogout() {
    return {
        type: USER_LOGOUT,
    };
}

/**
 * Loaded user fields
 *
 * @param  {IField} fields
 *
 * @return {object} An action object with a type of LOAD_USER_FIELDS_SUCCESS
 */
export function userFieldsLoaded(fields) {
    return {
        type: LOAD_USER_FIELDS_SUCCESS,
        fields,
    };
}

/**
 * Update user fields
 *
 * @param  {IField[]} fields
 *
 * @return {object} An action object with a type of UPDATE_USER_FIELDS
 */
export function updateUserFields(fields: IField[]) {
    return {
        type: UPDATE_USER_FIELDS,
        fields,
    };
}

/**
 * Load user fields
 *
 * @return {object} An action object with a type of LOAD_ALL_FIELDS
 */
export function loadAllFields() {
    return {
        type: LOAD_ALL_FIELDS,
    };
}

/**
 * Loading user fields
 *
 * @param  {bool} status
 *
 * @return {object} An action object with a type of LOAD_ALL_FIELDS_SUCCESS
 */
export function allFieldsLoading(status) {
    return {
        type: LOAD_ALL_FIELDS_LOADING,
        status,
    };
}

/**
 * Loaded user fields
 *
 * @param  {string} fields
 *
 * @return {object} An action object with a type of LOAD_ALL_FIELDS_SUCCESS
 */
export function allFieldsLoaded(fields) {
    return {
        type: LOAD_ALL_FIELDS_SUCCESS,
        fields,
    };
}

/**
 * Show all fields on map
 *
 * @param  {bool} show
 *
 * @return {object} An action object with a type of SHOW_ALL_FIELDS
 */
export function showAllFields(show) {
    return {
        type: SHOW_ALL_FIELDS,
        show,
    };
}

/**
 * Show all fields on map
 *
 * @param  {bool} show
 *
 * @return {object} An action object with a type of SHOW_SETTINGS
 */
export function showSettings(show) {
    return {
        type: SHOW_SETTINGS,
        show,
    };
}

/**
 * Show all fields on map
 *
 * @param  {bool} show
 *
 * @return {object} An action object with a type of HIDE_INFO_PANEL
 */
export function hideInfoPanel(show) {
    return {
        type: HIDE_INFO_PANEL,
        show,
    };
}

/**
 * Show all fields on map
 *
 * @param  {bool} show
 *
 * @return {object} An action object with a type of SHOW_SETTINGS
 */
export function showSpraying(show) {
    return {
        type: SHOW_SPRAYING,
        show,
    };
}

/**
 * Add leaflet map polygon to the list
 *
 * @param  {string} polygon
 *
 * @return {object} An action object with a type of ADD_POLYGON
 */
export function addPolygon(polygon) {
    return {
        type: ADD_POLYGON,
        polygon,
    };
}

/**
 * Add leaflet map polygons to the list
 *
 * @param  {string} polygon
 *
 * @return {object} An action object with a type of ADD_POLYGON
 */
export function addPolygons(polygons) {
    return {
        type: ADD_POLYGONS,
        polygons,
    };
}

/**
 * Edit leaflet map polygon to the list
 *
 * @param  {string} polygon
 *
 * @return {object} An action object with a type of EDIT_POLYGON
 */
export function editPolygon(polygon) {
    return {
        type: EDIT_POLYGON,
        polygon,
    };
}

/**
 * Update leaflet map polygon to the list
 * @param  {object} polygon
 *
 * @return {object} An action object with a type of ADD_POLYGON
 */
export function updatePolygon(polygon) {
    return {
        type: UPDATE_POLYGON,
        polygon,
    };
}

/**
 * Remove leaflet map polygon to the list
 * @param  {string} id
 *
 * @return {object} An action object with a type of ADD_POLYGON
 */
export function removePolygon(id) {
    return {
        type: REMOVE_POLYGON,
        id,
    };
}

/**
 * Clear leaflet map polygons list
 * @param  {string} id
 *
 * @return {object} An action object with a type of ADD_POLYGON
 */
export function clearPolygons(id) {
    return {
        type: CLEAR_POLYGONS,
    };
}

/**
 * Save token
 *
 * @param  {object} user
 * @param  {string} token
 *
 * @return {object} An action object with a type of SAVE_AUTHENTICATION
 */
export function saveAuthentication(user, token) {
    return {
        type: SAVE_AUTHENTICATION,
        user,
        token,
    };
}

/**
 * Change data mode
 *
 * @param  {string} mode
 *
 * @return {object} An action object with a type of CHANGE_MODE
 */
export function changeMode(mode) {
    return {
        type: CHANGE_MODE,
        mode,
    };
}

/**
 * Change field edit mode
 *
 * @param  {object} field
 *
 * @return {object} An action object with a type of EDIT_FIELD
 */
export function editField(field) {
    return {
        type: EDIT_FIELD,
        field,
    };
}

/**
 * Change field information mode
 *
 * @param  {object} field
 *
 * @return {object} An action object with a type of EDIT_FIELD
 */
export function editFieldInformation(field) {
    return {
        type: EDIT_FIELD_INFORMATION,
        field,
    };
}

/**
 * Select Field
 *
 * @param {object} data - The field data to be selected
 * @param {boolean} [all] - Optional flag to indicate selecting all fields
 *
 * @return {object} An action object with a type of SELECT_FIELD
 */
export function pickField(data, all?: boolean) {
    return {
        type: SELECT_FIELD,
        data,
        all: all ? all : false,
    };
}

/**
 * Select Field
 *
 * @param  {object} data
 * @param  {bool} all
 *
 * @return {object} An action object with a type of SELECT_FIELD
 */
export function setNdviBounds(data, all) {
    return {
        type: SET_NDVI_BOUNDS,
        data,
    };
}
export function setVisibleFields(data) {
    return {
        type: SET_VISIBLE_FIELDS,
        data,
    };
}
/**
 * Select Field To Merge
 *
 * @param  {object} data
 *
 * @return {object} An action object with a type of SELECT_FIELD_TO_MERGE
 */
export function mergeField(data) {
    return {
        type: SELECT_FIELD_TO_MERGE,
        data,
    };
}

/**
 * Refresh scouting data
 *
 * @param  {object} data
 *
 * @return {object} An action object with a type of REFRESH_SCOUTING_DATA
 */
export function refreshScoutingData() {
    return {
        type: REFRESH_SCOUTING_DATA,
    };
}

/**
 * Show scouting data
 *
 * @param  {object} data
 *
 * @return {object} An action object with a type of SHOW_SCOUTING_DATA
 */
export function showScoutingData(data) {
    return {
        type: SHOW_SCOUTING_DATA,
        data,
    };
}

/**
 * Load scouting list
 *
 * @param  {object} data
 *
 * @return {object} An action object with a type of REFRESH_SCOUTING_DATA
 */
export function loadScoutingList(data) {
    return {
        type: LOAD_SCOUTING_LIST,
        data,
    };
}

/**
 * Show problems
 *
 * @return {object} An action object with a type of TOGGLE_PROBLEMS
 */
export function toggleProblems() {
    return {
        type: TOGGLE_PROBLEMS,
    };
}

/**
 * Save map data
 *
 * @param  {object} center
 *
 * @return {object} An action object with a type of SAVE_MAP_CENTER
 */
export function saveMapCenter(center) {
    return {
        type: SAVE_MAP_CENTER,
        center,
    };
}

/**
 * Save map data
 *
 * @param  {object} center
 * @param  {object} bounds
 * @param  {object} size
 * @param  {object} zoom
 *
 * @return {object} An action object with a type of SAVE_MAP_DATA
 */
export function saveMapData(center, bounds, size, zoom) {
    return {
        type: SAVE_MAP_DATA,
        center,
        bounds,
        size,
        zoom,
    };
}

/**
 * Save map
 *
 * @param  {object} map
 *
 * @return {object} An action object with a type of SAVE_MAP
 */
export function saveMap(map) {
    return {
        type: SAVE_MAP,
        map,
    };
}

/**
 * Load available NDVI list for given field
 *
 * @param  {string} fieldId
 *
 * @return {object} An action object with a type of LOAD_NDVI
 */
export function loadNdviList(fieldId) {
    return {
        type: LOAD_NDVI_LIST,
        fieldId,
    };
}

export function loadFieldDetails(fieldId) {
    return {
        type: LOAD_FIELD_DETAILS,
        fieldId,
    };
}

/**
 * Dispatched when the NDVI list is loaded by the request saga
 *
 * @param  {array} list The NDVI data
 *
 * @return {object}      An action object with a type of LOAD_NDVI_LIST_SUCCESS passing the list array
 */
export function ndviListLoaded(list, hash) {
    return {
        type: LOAD_NDVI_LIST_SUCCESS,
        list,
        hash,
    };
}

/**
 * Load NDVI for given date and field
 *
 * @param  {string} date
 * @param  {bool} force
 *
 * @return {object} An action object with a type of LOAD_NDVI
 */
export function loadNdvi(date, force) {
    return {
        type: LOAD_NDVI,
        date,
        force,
    };
}

/**
 * Dispatched when the NDVI is loaded by the request saga
 *
 * @param  {string} date
 * @param  {string} url
 * @param  {object} bounds
 *
 * @return {object}      An action object with a type of LOAD_NDVI_SUCCESS passing the list array
 */
export function ndviLoaded(date, url, bounds, success) {
    return {
        type: LOAD_NDVI_SUCCESS,
        date,
        url,
        bounds,
        success,
    };
}

export function ndviDetailsLoaded(details) {
    return {
        type: LOAD_NDVI_DETAILS_SUCCESS,
        details,
    };
}

export function ndviExpensesLoaded(expenses) {
    return {
        type: LOAD_NDVI_EXPENSES_SUCCESS,
        expenses,
    };
}

/**
 * Load available reclamation image
 *
 * @param  {object} code
 *
 * @return {object} An action object with a type of LOAD_RECLAMATION
 */
export function loadReclamation(code) {
    return {
        type: LOAD_RECLAMATION,
    };
}

/**
 * Load reclamation image extent
 *
 * @param  {object} id
 * @param  {object} code
 * @param  {object} extent
 *
 * @return {object} An action object with a type of LOAD_RECLAMATION
 */
export function saveReclamationData(id, code, extent) {
    return {
        type: SAVE_RECLAMATION_DATA,
        id,
        code,
        extent,
    };
}

/**
 * Dispatched when the reclamation image is loaded by the request saga
 *
 * @param  {string} url
 * @param  {string} bounds
 *
 * @return {object}      An action object with a type of LOAD_RECLAMATION_SUCCESS passing the list array
 */
export function reclamationLoaded(url, bounds) {
    return {
        type: LOAD_RECLAMATION_SUCCESS,
        url,
        bounds,
    };
}

/**
 * Load fertilization data for for given field
 *
 * @param  {string} fertId
 * @param  {string} fieldId
 * @param  {string} date
 * @param  {string} norm
 * @param  {string} minNorm
 * @param  {string} fertContent
 *
 * @return {object} An action object with a type of LOAD_FERTILIZATION
 */
export function loadFertilization(fertId, fieldId, date, norm, minNorm, maxNorm, fertContent) {
    return {
        type: LOAD_FERTILIZATION,
        fertId,
        fieldId,
        date,
        norm,
        minNorm,
        maxNorm,
        fertContent,
    };
}

/**
 * Load fertilization data for for given field
 *
 * @param  {int} fertContent
 *
 * @return {object} An action object with a type of LOAD_FERTILIZATION
 */
export function saveFertContent(fertContent) {
    return {
        type: SAVE_NITROGEN_CONTENT,
        fertContent,
    };
}

/**
 * Dispatched when the fertilization data is loaded by the request saga
 *
 * @param  {object} params
 * @param  {object} data
 *
 * @return {object}      An action object with a type of LOAD_FERTILIZATION_SUCCESS passing the list array
 */
export function fertilizationLoaded(params, data) {
    return {
        type: LOAD_FERTILIZATION_SUCCESS,
        params,
        data,
    };
}

/**
 * Dispatched when the fertilization data is loaded by the request saga
 *
 * @param  {object} params
 * @param  {object} data
 *
 * @return {object}      An action object with a type of LOAD_FERTILIZATION_SUCCESS passing the list array
 */
export function resetFertilization() {
    return {
        type: RESET_FERTILIZATION,
    };
}

/**
 * Dispatched when loading the repositories fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_ERROR passing the error
 */
export function loadingError(error) {
    return {
        type: LOAD_ERROR,
        error,
    };
}

/**
 * Set menu groups opened states
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_ERROR passing the error
 */
export function updateFieldsGroups(data) {
    return {
        type: UPDATE_FIELD_GROUPS,
        data,
    };
}

/**
 * Set field filter
 *
 * @param  {object} filter
 *
 * @return {object}       An action object with a type of FIELD_FILTER passing filter
 */
export function setFieldFilter(filter) {
    return {
        type: FIELD_FILTER,
        filter,
    };
}

/**
 * Set field filter by field ID
 *
 * @param  {array} filter
 *
 * @return {object}       An action object with a type of FIELD_ID_FILTER passing filter
 */
export function setFieldIdFilter(filter) {
    return {
        type: FIELD_ID_FILTER,
        filter,
    };
}

/**
 * Load crops
 *
 * @return {object}       An action object with a type of LOAD_CROPS
 */
export function loadCrops() {
    return {
        type: LOAD_CROPS,
    };
}

/**
 * Save loaded crops
 *
 * @param  {object} crops Array of crops
 *
 * @return {object}       An action object with a type of LOAD_CROPS_SUCCESS passing crop list
 */
export function loadCropsSuccess(crops: any) {
    return {
        type: LOAD_CROPS_SUCCESS,
        crops,
    };
}

/**
 * Set simple action modal information
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_ERROR passing the error
 */
export function toggleSimpleActionModal(data) {
    return {
        type: TOGGLE_SIMPLE_ACTION_MODAL,
        data,
    };
}

/**
 * Set simple action modal information
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_ERROR passing the error
 */
export function toggleMobileMap(data) {
    return {
        type: TOGGLE_SHOW_MOBILE_MAP,
        data,
    };
}

/**
 * Set simple action modal information
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_ERROR passing the error
 */
export function toggleMobileModalSelect(data) {
    return {
        type: TOGGLE_MOBILE_MODAL_SELECT,
        data,
    };
}

/**
 * Set notification modal information
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_ERROR passing the error
 */
export function toggleNotificationModal(data) {
    return {
        type: TOGGLE_NOTIFICATION_MODAL,
        data,
    };
}

export function setFertilizationParams(data) {
    return {
        type: SET_FERTILIZATION_PARAMS,
        data,
    };
}

export function setHeaderSelectorDisability(status) {
    return {
        type: SET_HEADER_SELECTOR_DISABILITY,
        data: status,
    };
}

export function setDisableCompanySelect(status) {
    return {
        type: SET_DISABLE_COMPANY_SELECT,
        data: status,
    };
}

export function toggleShowFieldList() {
    return {
        type: TOGGLE_SHOW_FIELD_LIST,
    };
}

export function fieldsLoading(status) {
    return {
        type: FIELDS_LOADING,
        status,
    };
}

export function setMapAnalysisData(data) {
    return {
        type: SAVE_MAP_ANALYSIS,
        data,
    };
}

export function clearMapAnalysisData() {
    return {
        type: CLEAR_MAP_ANALYSIS,
    };
}

export function setGroupingState(state) {
    return {
        type: SET_GROUP_STATE,
        state,
    };
}

export function setSelectedGroupFields(selected) {
    return {
        type: SET_GROUP_SELECTED_FIELDS,
        selected,
    };
}
export function setScoutingLatLng(data: { lat: number | ''; lng: number | '' }) {
    return {
        type: SET_SCOUTING_LAT_LNG,
        data,
    };
}
export function setMobileInfoPanelIsClosed(data: boolean) {
    return {
        type: SET_INFOPANEL_ISOPEN,
        data,
    };
}

export function setTaskData(data) {
    return {
        type: SET_TASK_DATA,
        data,
    };
}

export function setEditingClosePopup(data: boolean) {
    return {
        type: SET_EDITING_CLOSE_POPUP,
        data,
    };
}
export function setClosePopupModalOpen(data: boolean) {
    return {
        type: SET_CLOSE_POPUP_MODAL_OPEN,
        data,
    };
}

export function setSplittingField(data) {
    return {
        type: SET_SPLITTING_FIELD,
        data,
    };
}

export function setFieldsFilterOpened(data) {
    return {
        type: SET_FIELDS_FILTER_OPENED,
        data,
    };
}

export function setVraNdviOverlays(overlays) {
    return {
        type: SET_VRA_NDVI_OVERLAYS,
        overlays,
    };
}

export function setVraNdviLoading(loading: boolean) {
    return {
        type: SET_VRA_NDVI_LOADING,
        loading,
    };
}

export function setVraMapLayers(layers) {
    return {
        type: SET_VRA_MAP_LAYERS,
        layers,
    };
}

export function setVraAnalysisOverlays(overlays) {
    return {
        type: SET_VRA_ANALYSIS_OVERLAYS,
        overlays,
    };
}

export function setLayerOpacity(opacity: number) {
    return {
        type: SET_LAYER_OPACITY,
        opacity,
    };
}
